module.exports = __webpack_public_path__ + "static/media/Logo.03bd143e.png";